import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Sun, Volume2, ArrowRight } from "lucide-react";
import api from "../../lib/api";
import { Reveal } from "./Reveal";

export const WordOfDay = () => {
  const [word, setWord] = React.useState(null);

  React.useEffect(() => {
    api.get("/yoruba/word-of-the-day").then((r) => setWord(r.data)).catch(() => {});
  }, []);

  if (!word) return null;

  return (
    <section className="bg-night text-cream" data-testid="word-of-day-section">
      <div className="max-w-4xl mx-auto px-6 pt-24">
        <Reveal>
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="relative rounded-3xl border border-gold/30 bg-gradient-to-br from-forest/40 to-night-surface p-8 md:p-10 overflow-hidden"
            data-testid="word-of-day-card"
          >
            <div className="flex items-center gap-2 mb-5">
              <Sun className="w-4 h-4 text-gold" />
              <p className="uppercase tracking-[0.25em] text-xs text-gold-soft">Word of the Day</p>
            </div>

            <div className="flex flex-wrap items-center gap-3 mb-2">
              <h3 className="font-serif text-4xl md:text-5xl text-gold" data-testid="word-of-day-term">
                {word.term}
              </h3>
              <span className="text-[10px] uppercase tracking-widest border border-cream/25 rounded-full px-2.5 py-0.5 text-cream/60">
                {word.type === "name" ? "Name" : "Word"}
              </span>
              {word.gender && (
                <span className="text-[10px] uppercase tracking-widest border border-cream/25 rounded-full px-2.5 py-0.5 text-cream/60">
                  {word.gender}
                </span>
              )}
            </div>

            {word.pronunciation && (
              <p className="flex items-center gap-2 text-cream/60 text-sm mb-4">
                <Volume2 className="w-4 h-4 text-gold-soft" />
                <span className="italic">{word.pronunciation}</span>
              </p>
            )}

            <p className="text-cream/85 text-lg leading-relaxed mb-2">{word.meaning}</p>
            {word.breakdown && (
              <p className="text-cream/60 leading-relaxed mb-6">{word.breakdown}</p>
            )}

            <Link
              to="/dictionary"
              data-testid="word-of-day-link"
              className="inline-flex items-center gap-2 text-sm font-semibold text-gold hover:text-gold-light transition-colors"
            >
              Explore the dictionary
              <ArrowRight className="w-4 h-4" />
            </Link>
          </motion.div>
        </Reveal>
      </div>
    </section>
  );
};

export default WordOfDay;
